<template>

	<form class="wrap--xsm__left margin-b-150" @submit.prevent="submitSelection">

		<section class="col-12 margin-b-75">

			<label>Navn på gruppen af tilvalg?</label>

			<input class="col-12" type="text" name="name" placeholder="Hvad er navnet?" minlength="2" maxlength="120" required v-model="newSelection.title">

		</section>

		<section class="col-12 padding-b-25 margin-b-75 border-b">

			<label>Hvor mange tilvalg skal der vælges? </label>

			<section class="select-lg">

				<ws-select :options="minOptionChoices" emptytext="Vælg antal tilvalg" v-model="newSelection.min_options" :useNull="true"></ws-select>

			</section>

		</section>

        <section class="col-12 padding-b-25 margin-b-75 border-b">

            <label>Benytter gruppen fælles tilbehør? </label>

            <section class="col-12 margin-b-75">

				<section class="radio-select col-6 margin-t-15">

					<section class="item">

						<label>
							<p>Ja</p>
							<input type="radio" name="shares-side-dishes" :value="true" v-model="newSelection.options_shares_side_dishes"></label>
						</label>

					</section>

					<section class="item">

						<label>
							<p>Nej</p>
							<input type="radio" name="shares-side-dishes" :value="false" v-model="newSelection.options_shares_side_dishes"></label>
						</label>

					</section>

				</section>

            </section>

        </section>

        <transition name="fade">
            <section class="col-12 padding-b-25 margin-b-75 border-b" v-if="newSelection.options_shares_side_dishes">

                <packaging :items="newSelection.packaging_items" @updateItems="updateItems"></packaging>

            </section>
        </transition>

		<section class="col-12">

			<button class="btn btn--md btn--secondary secondary--grey" :disabled="!validateForm || isSaving || shouldLock">

				<span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

				<span>Gem tilvalgsgruppe</span>

			</button>

		</section>

	</form>

</template>

<script>
	import {mapGetters} from 'vuex';
	import packagingCrud from './packaging/container.vue';
    export default {
        name: "selectionForm",
		props:['selection', 'shouldLock'],
        components:{
            'packaging':packagingCrud,
        },
        data(){
            return {
                newSelection:{
                    title:'',
                    min_options:0,
                    options_shares_side_dishes:false,
                    packaging_items:[],
                },
                isSaving:false,
				isCreating:false,
            };

        },
        computed:{
			...mapGetters({
				product:'product',
			}),
            minOptionChoices(){
                return {
                    1:'1 stk.',
                    2:'2 stk.',
                    3:'3 stk.',
                    4:'4 stk.',
                    5:'5 stk.',
                    6:'6 stk.',
                }
            },
			validateTitle(){
                return this.newSelection.title !== '' && String(this.newSelection.title).length > 0;
			},
			validateNumberOfChoices(){
                return parseInt(this.newSelection.min_options) > 0 && this.newSelection.min_options !== null;
			},
            validateSideDishes(){
                if(this.newSelection.options_shares_side_dishes){
                    return this.newSelection.packaging_items.length > 0;
                }

                return true;
            },
			validateForm(){
                return this.validateTitle && this.validateNumberOfChoices && this.validateSideDishes;
			}
        },
		methods:{
            submitSelection(){
                if(this.isSaving){
                    return;
				}

				if(this.isCreating){
				    return this.createSelection();
				}

				this.updateSelection();
			},
			createSelection(){
				this.isSaving = true;
				const data = {
				    title: this.newSelection.title,
					min_options: parseInt(this.newSelection.min_options),
					max_options: 0,
					options:[],
                    options_shares_side_dishes:this.newSelection.options_shares_side_dishes,
                    packaging_items:this.newSelection.packaging_items,
				};
				axios.post(`/api/admin/product/${this.product.id}/selection`, data).then(response => {
				    this.newSelection = {
                        title:'',
                        min_options:0,
                    };
				    this.isSaving = false;
				    this.$emit('completed', response.data.data);
				});
			},
			updateSelection(){
                this.isSaving = true;
                const data = {
                    title: this.newSelection.title,
                    min_options: parseInt(this.newSelection.min_options),
                    max_options: 0,
                    options_shares_side_dishes:this.newSelection.options_shares_side_dishes,
                    packaging_items:this.newSelection.packaging_items,
                };
				axios.put(`/api/admin/product/${this.product.id}/selection/${this.selection.id}`, data).then(response=>{
                    this.isSaving = false;
                    data.id = this.selection.id;
                    data.isUpdating = true;
                    this.$emit('completed', data);
				});
			},
            updateItems(updatedItemsArray){
                this.newSelection.packaging_items = updatedItemsArray;
            }
		},
		created(){
            if(this.selection){

                this.newSelection = this.selection;

                if(!this.selection.options_shares_side_dishes){
                    this.newSelection.options_shares_side_dishes = false;
                }

                if(!this.selection.packaging_items){
                    this.newSelection.packaging_items = [];
                }

                return;
			}


			this.isCreating = true;
		}
    }
</script>

<style scoped>

</style>
